// src/firebase/firebase.js
// Firebase SDK (modular, v10+)
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

// [lock] App Check (reCAPTCHA Enterprise)
// import { initializeAppCheck, ReCaptchaEnterpriseProvider, onTokenChanged } from 'firebase/app-check'

// [gear] Config depuis .env (Vite)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

// [ok] App Check côté navigateur (aucun "debug token" nécessaire)
//if (typeof window !== 'undefined') {
//  const siteKey = import.meta.env.VITE_RECAPTCHA_E_SITE_KEY // mets-la dans .env
//  if (!siteKey) {
//    console.error(
//      '[AppCheck] VITE_RECAPTCHA_E_SITE_KEY manquante. ' +
//      'Ajoute ta clé de site reCAPTCHA Enterprise dans .env et autorise ton domaine dans la console App Check.'
//    )
//  } else {
//    const appCheck = initializeAppCheck(app, {
//      provider: new ReCaptchaEnterpriseProvider(siteKey),
//      isTokenAutoRefreshEnabled: true,
//    })
// (facultatif mais utile) : tu verras "token actif: XXXXX..." si tout est bon
//    onTokenChanged(appCheck, (token) => {
//      if (token?.token) {
//        console.log('[AppCheck] token actif:', token.token.slice(0, 12) + '...')
//      } else {
//        console.warn('[AppCheck] pas de token (vérifie domaines autorisés dans App Check).')
//      }
//    })
//  }
//}

// Exports habituels
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
export const db = getFirestore(app)

// [bucket] version simple : on garde exactement la valeur du .env
export const storage = getStorage(
  app,
  `gs://${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET}`
)
// Debug facultatif
console.log('[BUCKET]', import.meta.env.VITE_FIREBASE_STORAGE_BUCKET)

export const functions = getFunctions(app, "us-central1")

export default app
